import { lazy, Suspense, type ComponentType } from "react";
import { AgentJob, AiUsageW, GitLog, NeedsYou, ProjectFile } from "./personal";
import type { WidgetType } from "../../shared/types";
import type { WP } from "./data";
import { Agent, Feed } from "./agents";
import { List, Status, Table } from "./rows";
import { Chart, Goal, Metric } from "./stats";
import { Brief } from "./brief";
import { Habits, Heading, Links, Notes, Sticky, Tasks } from "./local";
import { Calendar, Clock, Countdown, SunMoon, Timer, Weather } from "./time";
import { Embed, ImageW, Retired } from "./media";
import { Custom } from "./custom";
import { BookmarksW, SeoW } from "./ours";
import { ActionButton } from "./action";
import { ConnectionsW } from "./connections";

const MapLazy = lazy(() => import("./map"));
function MapW(p: WP) {
  return (
    <Suspense fallback={<div className="map map-loading" />}>
      <MapLazy {...p} />
    </Suspense>
  );
}

/**
 * The status lights, retired on 15 Oct 2026: a saved one goes on drawing the
 * lights something sends it, and one with none (never connected, or fed one
 * number) says it was retired, with Remove and Make it my own.
 */
function StatusW(p: WP) {
  return p.stream?.items?.length ? <Status {...p} /> : <Retired {...p} />;
}

export const RENDER: Record<WidgetType, ComponentType<WP>> = {
  metric: Metric,
  chart: Chart,
  goal: Goal,
  list: List,
  table: Table,
  status: StatusW,
  feed: Feed,
  agent: Agent,
  map: MapW,
  brief: Brief,
  custom: Custom,
  notes: Notes,
  tasks: Tasks,
  heading: Heading,
  sticky: Sticky,
  links: Links,
  clock: Clock,
  // retired widgets: a saved world clock is a clock with places, a saved radio says it went
  worldclock: Clock,
  countdown: Countdown,
  timer: Timer,
  radio: Retired,
  image: ImageW,
  embed: Embed,
  calendar: Calendar,
  weather: Weather,
  sun: SunMoon,
  habits: Habits,
  file: ProjectFile,
  job: AgentJob,
  needsyou: NeedsYou,
  usage: AiUsageW,
  gitlog: GitLog,
  connections: ConnectionsW,
  action: ActionButton,
  seo: SeoW,
  bookmarks: BookmarksW,
};

// Widgets that draw their own empty state rather than the data gate. The brief
// is one: an agent writes it, so it offers to ask for one rather than to connect.
export const LOCAL_TYPES = new Set<WidgetType>(["notes", "tasks", "heading", "sticky", "links", "clock", "worldclock", "countdown", "timer", "radio", "image", "embed", "calendar", "weather", "sun", "habits", "agent", "brief", "file", "job", "needsyou", "usage", "gitlog", "connections", "action"]);
